import { render, staticRenderFns } from "./product_selector.vue?vue&type=template&id=3b35f8b6&scoped=true"
import script from "./product_selector.vue?vue&type=script&lang=js"
export * from "./product_selector.vue?vue&type=script&lang=js"
import style0 from "./product_selector.vue?vue&type=style&index=0&id=3b35f8b6&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b35f8b6",
  null
  
)

export default component.exports